import produce from "immer"
import { CcResponse } from "server/models"

import { NO } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcResponse: CcResponse = {
    id: null,
    accountId: null,
    projectId: null,
    response: "",
    approved: NO,
    translations: null,
    creator: null,
    module: null,
    order: 0,
}

const initCcResponseState: types.CcResponseState = {
    moduleResponseList: {},

    responseList: {},
    responseEdit: initCcResponse,

    reloadList: true,
    reloadEdit: true,
}

const ccResponseReducer = produce((
    draft: types.CcResponseState = initCcResponseState,
    action: ActionTypes = null,
): types.CcResponseState => {
    switch (action.type) {
        case types.CC_MODULE_RESPONSE_LIST:
            draft.moduleResponseList = { ...draft.moduleResponseList, ...action.moduleResponseList }
            return draft

        case types.CC_RESPONSE_LIST:
            draft.responseList = { ...draft.responseList, ...action.responseList }
            return draft

        case types.CC_RESPONSE_EDIT:
            draft.responseEdit = action.response
            return draft

        case types.CC_RESPONSE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_RESPONSE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccResponseReducer
